/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartTableEdgeLabel = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M2 7h2v14H2zm4-4h16v2H6zm0 18h16V7H6zm9-12h5v2h-5zm0 4h5v2h-5zm0 4h5v2h-5zM8 9h5v2H8zm0 4h5v2H8zm0 4h5v2H8z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgChartTableEdgeLabel as ChartTableEdgeLabel };
